export default __webpack_public_path__ + "static/media/ico-PlusSquare.f4b30be7.svg";